/**
 * Founder's Birthday Event
 * ------------------------
 * A purely cosmetic, self-expiring 24-hour celebration.
 * Fixed global window: 2026-07-19T23:00:00Z -> 2026-07-20T23:00:00Z
 * (midnight BST on 20 July through midnight BST on 21 July).
 *
 * This file is intentionally self-contained: everything the event needs
 * (dates + the gating check) lives here so the whole feature can be
 * deleted later by removing this file and its one import in <BirthdayEvent />.
 */

export const BIRTHDAY_EVENT_START = new Date("2026-07-19T23:00:00Z");
export const BIRTHDAY_EVENT_END = new Date("2026-07-20T23:00:00Z");

/** True only while "now" falls inside the Founder's Birthday window. */
export function isBirthdayEventActive(now: Date = new Date()): boolean {
  return now >= BIRTHDAY_EVENT_START && now < BIRTHDAY_EVENT_END;
}
